/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { APPLICATION_VIEW_OFFICE } from '@gh/builder-shared-data';
import { createRoute } from '@gh/common-shared';
import { CSMasterDetailsComponent } from './components/cs-master-details/cs-master-details.component';
import { CSMasterListTabComponent } from './components/cs-master-list/cs-master-list-tab.component';
import { JobAdminTabContainerComponent } from './components/job-admin-tab-container/job-admin-tab-container.component';
import { JobLetterListTabComponent } from './components/job-letter-list-tab/job-letter-list-tab.component';
import { JobSpecTemplateDetailsComponent } from './components/job-spec-template-details/job-spec-template-details.component';
import { JobSpecTemplateListTabComponent } from './components/job-spec-template-list-tab/job-spec-template-list-tab.component';
import { JobStageListTabComponent } from './components/job-stage-list-tab/job-stage-list-tab.component';
import { CSMasterBusinessService } from './resources/cs-master-business.service';
import { JobLetterListTabBusinessService } from './resources/job-letter-list-tab-business.service';
import { JobSpecTemplateDetailsBusinessService } from './resources/job-spec-template-details-business.service';
import { JobStageListBusinessService } from './resources/job-stage-list-business.service';

const routes = [
  createRoute({
    component: JobAdminTabContainerComponent,
    path: '',
    children: [
      createRoute({
        component: JobLetterListTabComponent,
        init: JobLetterListTabBusinessService,
        path: 'job-letters',
        leave: true,
        auth: {
          applicationView: APPLICATION_VIEW_OFFICE,
          permission: [
            'Setup.JobAdmin.JobLetters.MANAGE',
          ],
        },
      }),
      createRoute({
        component: JobSpecTemplateListTabComponent,
        path: 'job-spec-templates',
        auth: {
          applicationView: APPLICATION_VIEW_OFFICE,
          permission: [
            'Setup.JobAdmin.JobSpecTemplates.LIST',
          ],
        },
      }),
      createRoute({
        component: CSMasterListTabComponent,
        path: 'cs-masters',
        auth: {
          applicationView: APPLICATION_VIEW_OFFICE,
          permission: [
            'Setup.JobAdmin.ColorSelectionMasters.LIST',
          ],
        },
      }),
      createRoute({
        component: JobStageListTabComponent,
        init: JobStageListBusinessService,
        path: 'job-stages',
        auth: {
          applicationView: APPLICATION_VIEW_OFFICE,
          permission: [
            'Setup.JobAdmin.JobStages.LIST',
          ],
        },
      }),
      createRoute({
        component: JobSpecTemplateListTabComponent,
        path: 'job-spec-templates',
        auth: {
          applicationView: APPLICATION_VIEW_OFFICE,
          permission: [
            'Setup.JobAdmin.JobSpecTemplates.LIST',
          ],
        },
      }),
    ],
  }),
  createRoute({
    component: CSMasterDetailsComponent,
    path: 'cs-masters/new',
    init: CSMasterBusinessService,
    leave: true,
    auth: {
      applicationView: APPLICATION_VIEW_OFFICE,
      permission: [
        'Setup.JobAdmin.ColorSelectionMasters.CREATE',
      ],
    },
  }),
  createRoute({
    component: CSMasterDetailsComponent,
    path: 'cs-masters/:cSMasterDetailsId',
    init: CSMasterBusinessService,
    leave: true,
    auth: {
      applicationView: APPLICATION_VIEW_OFFICE,
      permission: [
        'Setup.JobAdmin.ColorSelectionMasters.EDIT',
        'Setup.JobAdmin.ColorSelectionMasters.VIEW',
      ],
    },
  }),
  createRoute({
    component: JobSpecTemplateDetailsComponent,
    init: JobSpecTemplateDetailsBusinessService,
    path: 'job-spec-templates/new',
    leave: true,
    auth: {
      applicationView: APPLICATION_VIEW_OFFICE,
      permission: [
        'Setup.JobAdmin.JobSpecTemplates.CREATE',
      ],
    },
  }),
  createRoute({
    component: JobSpecTemplateDetailsComponent,
    init: JobSpecTemplateDetailsBusinessService,
    path: 'job-spec-templates/:jobSpecTemplateId',
    leave: true,
    auth: {
      applicationView: APPLICATION_VIEW_OFFICE,
      permission: [
        'Setup.JobAdmin.JobSpecTemplates.EDIT',
        'Setup.JobAdmin.JobSpecTemplates.VIEW',
      ],
    },
  }),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BuilderSetupJobAdminRoutingModule {
}
